import {ContextBarService} from 'src/app/diagram-interaction/context-bar/context-bar.service';
import {AngularComponentService} from '../angular-component.service';
import {mxContextBar} from './mxContextBar';

declare let mxVertexHandler;
declare let mxEdgeHandler;
declare let mxEvent;
declare let mxUtils;

export function initContextBarHandler(
  compSvc: AngularComponentService,
  contextBarSvc: ContextBarService
) {
  const contextBarHandler = mxUtils.bind(this, function () {
    const contextBarOptions = contextBarSvc.getOptions();

    if (!this.contextBar) {
      const contextBarComponent = compSvc.initContextBarComponent(contextBarOptions);

      this.contextBar =
        contextBarComponent && new mxContextBar(this, contextBarComponent, contextBarSvc);
    }

    if (this.getSelectionCount() === 0 || !contextBarOptions?.length) {
      this.contextBar?.destroy();

      return;
    }

    this.contextBar?.redraw();
  });

  // Event listeners for init, destroy and redraw context toolbar.
  this.selectionModel.addListener(mxEvent.CHANGE, contextBarHandler);
  this.addListener(mxEvent.HANDLE_CONTEXT_BAR, contextBarHandler);

  // Extend mxVertexHandler and mxEdgeHandler to hide context toolbar on dragging and resizing.
  for (const handler of [mxVertexHandler, mxEdgeHandler]) {
    /**
     * Function: mouseMove
     *
     * Handles the event by hiding context toolbar on dragging and resizing.
     */
    const mouseMove = handler.prototype.mouseMove;

    handler.prototype.mouseMove = function (sender, me) {
      mouseMove.apply(this, arguments);

      if (
        this.graph.contextBar?.contextBarNode &&
        (this.graph.isDragging() || this.graph.isResizing())
      ) {
        this.graph.contextBar.contextBarNode.style.display = 'none';
      }
    };

    /**
     * Function: mouseUp
     *
     * Handles the event by showing context toolbar after dragging or resizing are finished.
     */
    const mouseUp = handler.prototype.mouseUp;

    handler.prototype.mouseUp = function (sender, me) {
      mouseUp.apply(this, arguments);

      if (this.graph.contextBar?.contextBarNode && !this.graph.contextBar.shapeOutOfVisibleArea) {
        this.graph.contextBar.contextBarNode.style.display = '';
      }
    };
  }
}
